export function attachQuerySocketEvents(socket, client, userId, onAccessDenied) {
  const prefix = ["account", userId];
  const classesChanged = () => {
    client.cancelQueries({ queryKey: [...prefix, "classes"] });
    client.invalidateQueries({ queryKey: [...prefix, "classes"] });
    client.invalidateQueries({ queryKey: [...prefix, "members"] });
  };
  const feedChanged = () => {
    client.cancelQueries({ queryKey: [...prefix, "feed"], type: "inactive" });
    client.invalidateQueries({ queryKey: [...prefix, "feed"], type: "inactive", refetchType: "none" });
  };
  const denied = () => { client.clear(); onAccessDenied(); };
  const sectionAccessChanged = () => {
    // Do not keep persisted content available after the owner changes access.
    const content = query => query.queryKey[0] === "account" && query.queryKey[1] === userId
      && ["classes", "feed", "members", "community-preview", "dm-list", "dm-messages", "community-channel", "channel-unread"].includes(query.queryKey[2]);
    client.cancelQueries({ predicate: content });
    client.removeQueries({ predicate: content });
    client.invalidateQueries({ queryKey: [...prefix, "group"] });
  };
  const messagesChanged = () => {
    for (const type of ["dm-list", "dm-messages"]) {
      client.invalidateQueries({ queryKey: [...prefix, type], refetchType: "none" });
    }
  };
  const membershipChanged = event => {
    if (String(event?.removedId || event?.leftMemberId) === String(userId)) denied();
    else client.invalidateQueries({ queryKey: prefix });
  };
  const handlers = [
    ["community:section-access-changed", sectionAccessChanged],
    ["class:video-status", event => client.invalidateQueries({ queryKey: event?.groupId ? [...prefix, "classes", String(event.groupId)] : [...prefix, "classes"] })],
    ["class:video-ready", () => client.invalidateQueries({ queryKey: [...prefix, "classes"] })],
    ...["message:new", "message:viewed", "message:deleted"].map(event => [event, messagesChanged]),
    ...["class:expired", "class:rescheduled", "class:deleted", "class:ended", "class:recording-ready", "class:access-changed"].map(event => [event, classesChanged]),
    ...["workspace:memberJoin", "workspace:roleChanged", "workspace:memberRemoved", "workspace:memberLeft"].map(event => [event, membershipChanged]),
    ["feed:updated", feedChanged], ["course:access-denied", event => {
      if (["SUBSCRIPTION_REQUIRED", "COURSE_ACCESS_DENIED", "COURSE_NOT_FOUND"].includes(event?.code)) denied();
    }],
  ];
  handlers.forEach(([event, handler]) => socket.on(event, handler));
  return () => handlers.forEach(([event, handler]) => socket.off(event, handler));
}
